// src/components/modal.ts

interface ConfirmOptions {
  title?: string;
  okText?: string;
  cancelText?: string;
}

interface AlertOptions {
  title?: string;
  okText?: string;
}

/**
 * 应用内确认对话框,返回 Promise<boolean>。
 */
export function showConfirm(
  message: string,
  { title = '确认', okText = '确定', cancelText = '取消' }: ConfirmOptions = {},
): Promise<boolean> {
  return new Promise<boolean>(resolve => {
    const overlay = document.createElement('div');
    overlay.className = 'modal-overlay';
    overlay.innerHTML = `
      <div class="modal-card" role="dialog" aria-modal="true">
        <h3 class="modal-title">${title}</h3>
        <p class="modal-message">${message}</p>
        <div class="modal-actions">
          <button class="btn btn-secondary modal-cancel">${cancelText}</button>
          <button class="btn btn-primary modal-ok">${okText}</button>
        </div>
      </div>
    `;
    document.body.appendChild(overlay);
    const close = (result: boolean): void => {
      overlay.classList.remove('modal-show');
      overlay.classList.add('modal-hide');
      setTimeout(() => overlay.remove(), 200);
      resolve(result);
    };
    overlay.querySelector('.modal-ok')?.addEventListener('click', () => close(true));
    overlay.querySelector('.modal-cancel')?.addEventListener('click', () => close(false));
    overlay.addEventListener('click', e => { if (e.target === overlay) close(false); });
    requestAnimationFrame(() => overlay.classList.add('modal-show'));
  });
}

/**
 * 应用内单按钮提示框,返回 Promise<void>。
 */
export function showAlert(
  message: string,
  { title = '提示', okText = '我知道了' }: AlertOptions = {},
): Promise<void> {
  return new Promise<void>(resolve => {
    const overlay = document.createElement('div');
    overlay.className = 'modal-overlay';
    overlay.innerHTML = `
      <div class="modal-card" role="dialog" aria-modal="true">
        <h3 class="modal-title">${title}</h3>
        <p class="modal-message">${message}</p>
        <div class="modal-actions">
          <button class="btn btn-primary modal-ok">${okText}</button>
        </div>
      </div>
    `;
    document.body.appendChild(overlay);
    const close = (): void => {
      overlay.classList.remove('modal-show');
      overlay.classList.add('modal-hide');
      setTimeout(() => overlay.remove(), 200);
      resolve();
    };
    overlay.querySelector('.modal-ok')?.addEventListener('click', close);
    requestAnimationFrame(() => overlay.classList.add('modal-show'));
  });
}
